export class WaystarAuthStatusImages {
    authtype?:string;
    effective?:boolean;
    imageLocators?:string[];
}